import { PromoAnalyticsService } from '@analytics/feature';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BannerSearchItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { HeaderModeSwitcherService, SearchProductModeSwitcherService } from '@sdvor/layout/feature';
import { SdvorSearchBoxContainerComponent } from '@sdvor/search/ui/v2';
import { InViewportDirective, OutsideViewportDirective, SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { combineLatest, map, Observable } from 'rxjs';

@Component({
  selector: 'sd-banner-search',
  imports: [
    AsyncPipe,
    SdvorSearchBoxContainerComponent,
    SdvorIconComponent,
    OutsideViewportDirective,
    RouterLink,
    NgOptimizedImage,
    SdvorGenericLinkComponent,
    InViewportDirective,
  ],
  templateUrl: './banner-search.component.html',
  styleUrls: ['./banner-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerSearchComponent implements OnInit, OnDestroy {
  isTablet$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktop$: Observable<boolean> = this.deviceService.isDesktopLgUp$;

  bannerSearch$: Observable<BannerSearchItem | undefined>;

  constructor(
    public deviceService: DeviceService,
    private promoService: PromoService,
    private headerModeSwitcherService: HeaderModeSwitcherService,
    private searchProductModeSwitcherService: SearchProductModeSwitcherService,
    private promoAnalyticsService: PromoAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.bannerSearch$ = combineLatest({
      promo: this.promoService.getPromo(),
      isTablet: this.isTablet$,
      isDesktop: this.isDesktop$,
    }).pipe(
      map(({ promo, isTablet, isDesktop }) => {
        const banner = promo?.bannerSearch;

        if (!banner) {
          return undefined;
        }
        const { url } = banner;

        return {
          ...banner,
          url: isDesktop ? url.isDesktop : isTablet ? url.isTablet : url.isMobile,
        };
      }),
    );
  }

  onClickBanner(banner: BannerSearchItem): void {
    this.promoAnalyticsService.onClickBanner({
      id: banner?.id,
      name: banner?.name,
      position: 'main_page',
    });
  }

  onBannerIntersect(banner: BannerSearchItem): void {
    this.promoAnalyticsService.onShowBanner({
      id: banner?.id,
      name: banner?.name,
      position: 'main_page',
    });
  }

  ngOnDestroy(): void {
    this.headerModeSwitcherService.changeMode(true);
    this.searchProductModeSwitcherService.changeMode(true);
  }

  updateVisibility(isOutside: boolean): void {
    this.searchProductModeSwitcherService.changeMode(isOutside);
    this.headerModeSwitcherService.changeMode(isOutside);
  }
}
